import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="referenzwerte"
export default class extends Controller {
	initialize() {
		const inputDatum = this.element.querySelector("[data-datum-target='input']")
		if (inputDatum) inputDatum.dataset.action = inputDatum.dataset.action + " change->referenzwerte#update"
	}

	connect() {
		// Alle Inputfelder die angepasst werden sollen finden
		this.inputs = this.element.querySelectorAll("input[data-referenzwerte]")

		// Referenzwerte der einzelnen Inputs erstellen und in einer Map speichern
		this.referenzdatenMap = new Map()

		for (const input of this.inputs) {
			const jsonObjekt = JSON.parse(input.dataset.referenzwerte)
			const datumsMap = new Map(Object.entries(jsonObjekt))
			this.referenzdatenMap.set(input, datumsMap)
		}
	}

	update({ currentTarget }) {
		// console.log("referenzwerte#update")
		const datum = moment(currentTarget.value, "YYYY-M-D")
		if (!datum.isValid()) return

		const datumString = datum.format("YYYY-MM-DD")

		// ReferenzInputs aktualisieren
		for (const input of this.inputs) {
			const datumZuWertMap = this.referenzdatenMap.get(input)
			const referenzwert = datumZuWertMap.get(datumString)

			if (referenzwert) {
				input.value = new Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(referenzwert)
				input.dispatchEvent(new Event("input"))
			}
		}
	}
}
